export * from './lib/get-product-codename';
